<div class="no-result">
  <img src="assets/empty-box.svg" alt="empty" class="no-result-icon" />
  <h3 class="no-results">{{ message }}</h3>
</div>
